import styled from 'styled-components';

import {
  Flex,
} from 'web-styled';

interface DropArea {
  isDragActive: boolean
}

export const StyledDropArea = styled(Flex).attrs<DropArea>({
  column: true,
  spacing: 10,
  align: 'center',
  justify: 'center',
})`
  width: 100%;
  border: 1px dashed ${props => (props.isDragActive ? '#39ca74' : '#b0b0b0')};
  border-radius: 10px;
  outline: none;
  padding: 70px 20px;
  background-color: ${props => (props.isDragActive ? '#f9f9f9' : 'transparent')};
`;
